import AllAdmins from './AllAdmins';
import AdminUserDetails from './AdminUserDetails';
import './styles.scss';

const exports = { AllAdmins, AdminUserDetails };

export default exports;
